module.exports = __webpack_public_path__ + "des-moines-logo.8d5f9274befb1dbc1e15a89afae9fb18.png";